import { DomainsActions, DomainsState } from '../types';
import { getType } from '@anm/helpers/saga/typesafe-actions';
import { Reducer } from 'redux';

import { initialDomainsState } from '.';
import { fetchDomainsListAsync } from '../actions';

const fetchDomainsReducer: Reducer<DomainsState, DomainsActions> = (state = initialDomainsState, action) => {
  switch (action.type) {
    case getType(fetchDomainsListAsync.request): {
      return {
        ...state,
        fetchList: {
          ...state.fetchList,
          isPending: true
        }
      };
    }
    case getType(fetchDomainsListAsync.success): {
      return {
        ...state,
        list: action.payload,
        fetchList: {
          ...state.fetchList,
          isPending: false
        }
      };
    }
    case getType(fetchDomainsListAsync.failure): {
      return {
        ...state,
        fetchList: {
          ...state.fetchList,
          isPending: false,
          isError: true,
          error: action.payload
        }
      };
    }

    default:
      return state;
  }
};

export default fetchDomainsReducer;
